/**
 * Página de look — Apodemia (iurop-look-page.liquid)
 *
 * - Muestra el look que indica ?look=… : primero busca un bloque con ese ID
 *   (data-look-id) y, si no lo hay, lo interpreta como índice (def. 0).
 * - "Comprar el Look": añade TODOS los productos del look al carrito
 *   (/cart/add.js) y abre el sidecart vía cart:updated.
 */
(function () {
  'use strict';

  function setupSticky(item) {
    if (!item) return;
    var mainBtn = item.querySelector('.apodemia-look__buy:not(.apodemia-look__buy--sticky)');
    var sticky = item.querySelector('[data-look-sticky]');
    if (!mainBtn || !sticky || !('IntersectionObserver' in window)) return;

    function show(on) {
      if (on) {
        sticky.hidden = false;
        void sticky.offsetHeight; // fuerza reflow para animar el translate
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }
    sticky.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform' && !sticky.classList.contains('is-visible')) {
        sticky.hidden = true; // al ocultarse del todo, fuera del flujo
      }
    });

    // Se muestra cuando el botón principal deja de verse (scroll hacia abajo).
    new IntersectionObserver(function (entries) {
      show(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -15% 0px' }).observe(mainBtn);
  }

  function init(root) {
    var items = Array.from(root.querySelectorAll('[data-look-item]'));
    if (!items.length) return;

    // Selección por query param (?look=…).
    // 1º por ID del bloque (data-look-id, estable al reordenar); si no casa
    // ninguno, se acepta el índice numérico de siempre (?look=0,1,2…).
    var idx = 0;
    try {
      var raw = new URLSearchParams(window.location.search).get('look');
      if (raw != null) {
        var wanted = String(raw).trim().toLowerCase();
        var byId = -1;
        items.forEach(function (it, i) {
          if (byId === -1 && (it.getAttribute('data-look-id') || '').toLowerCase() === wanted && wanted !== '') byId = i;
        });
        if (byId > -1) {
          idx = byId;
        } else {
          var n = parseInt(raw, 10);
          if (!isNaN(n) && n >= 0 && n < items.length) idx = n;
        }
      }
    } catch (e) { /* noop */ }
    items.forEach(function (it, i) {
      it.hidden = i !== idx;
    });

    // Sticky "Comprar el Look" del look activo: se revela al pasar el botón
    // principal (mismo patrón que el sticky ATC de la PDP). El botón del sticky
    // ya lleva data-look-add → lo engancha el bucle de abajo.
    setupSticky(items[idx]);

    // Comprar el look completo
    root.querySelectorAll('[data-look-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var ids = [];
        try { ids = JSON.parse(btn.getAttribute('data-variants')); } catch (e) { /* noop */ }
        if (!ids.length) return;
        btn.disabled = true;
        // Propiedades ocultas (_): agrupan el look como item compacto en el sidecart
        var lookLabel = btn.getAttribute('data-look-label') || '';
        var lookImg = btn.getAttribute('data-look-image') || '';
        var props = null;
        if (lookLabel) {
          props = { _look: lookLabel };
          if (lookImg) props._look_img = lookImg;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) {
            var it = { id: id, quantity: 1 };
            if (props) it.properties = props;
            return it;
          }) }),
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
            );
          })
          .catch(function () {})
          .finally(function () {
            btn.disabled = false;
          });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-look-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-look-page]');
    if (root) init(root);
  });
})();
